import { memo, Suspense } from 'react'
import MainContainer from '../components/MainContainer'
import PageLoadingIndicator from '../components/PageLoadingIndicator'
import { Outlet, useLocation } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/App.less'

const HomeLayout = function() {
    const location = useLocation();

    // Suspense lives inside the layout so the navbar and footer stay mounted while a page chunk loads.
    // The key remounts only the page on navigation, not the whole layout.
    return (
        <MainContainer>
            <Suspense fallback={<PageLoadingIndicator />}>
                <Outlet key={location.pathname} />
            </Suspense>
        </MainContainer>
    )
}

export default memo(HomeLayout);
